import * as React from "react";
import type { SVGProps } from "react";

const SvgHelpContact = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    {...props}
  >
    <defs>
      <path id="help-contact_svg__a" d="M.001 0H20v20H.001z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="help-contact_svg__b" fill="#fff">
        <use xlinkHref="#help-contact_svg__a" />
      </mask>
      <path
        fill="currentColor"
        d="M15.175 18.559a.781.781 0 0 0-.81-1.336 8.43 8.43 0 0 1-4.364 1.215c-4.653 0-8.438-3.785-8.438-8.438 0-4.652 3.785-8.437 8.438-8.437 4.652 0 8.437 3.785 8.437 8.437a8.4 8.4 0 0 1-1.43 4.683.78.78 0 1 0 1.297.868A9.95 9.95 0 0 0 20 10c0-2.67-1.04-5.182-2.93-7.071A9.93 9.93 0 0 0 10-.001 9.94 9.94 0 0 0 2.929 2.93 9.93 9.93 0 0 0 .001 9.999a9.94 9.94 0 0 0 2.928 7.073A9.94 9.94 0 0 0 10 20c1.828 0 3.617-.5 5.174-1.441m-4.433-6.41v-1.05a3.254 3.254 0 0 0 2.497-3.285c-.065-1.688-1.449-3.06-3.152-3.124a3.28 3.28 0 0 0-2.417.917 3.2 3.2 0 0 0-.99 2.323.78.78 0 0 0 1.562 0c0-.455.181-.88.511-1.197.34-.328.794-.5 1.275-.482.893.034 1.617.746 1.65 1.622a1.694 1.694 0 0 1-1.34 1.716c-.682.15-1.158.74-1.158 1.434v1.126a.781.781 0 0 0 1.562 0m-.78 3.515a.782.782 0 1 1 0-1.563.782.782 0 0 1 0 1.563"
        mask="url(#help-contact_svg__b)"
      />
    </g>
  </svg>
);
export default SvgHelpContact;
